import { heroStats, heroTags, heroPosters } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden scroll-mt-24">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-50 to-background-50" />
      <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-primary-200/40 blur-3xl" />
      <div className="absolute top-10 right-0 w-[360px] h-[360px] rounded-full bg-accent-200/30 blur-3xl" />

      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-7 animate-soft-rise">
            <span className="inline-flex items-center gap-2 bg-background-50 border border-primary-200 text-primary-700 text-xs md:text-sm font-medium px-3 py-1.5 rounded-full">
              <i className="ri-leaf-line" />
              青苹果影院 · 最全青春片库
            </span>

            <h1 className="mt-5 text-3xl md:text-5xl font-black text-foreground-950 leading-[1.18] tracking-tight">
              青春电影大全
              <span className="text-primary-600">：</span>
              <br className="hidden md:block" />
              校园片、清纯少女、初恋小清新片单一次看够
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              从青涩校园恋曲到清新纯爱故事，我们把<strong className="text-foreground-800 font-semibold">校园片、初恋电影、小清新佳作</strong>按心情重新整理。无论是想重温学生时代的心动瞬间，还是寻找轻松治愈的观影选择，都能在这里找到合口味的那一部。
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              {heroTags.map((tag, idx) => (
                <a
                  key={tag}
                  href="#category"
                  className={`text-xs md:text-sm px-3 py-1.5 rounded-full border transition-colors whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-background-50 border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
                  }`}
                >
                  {tag}
                </a>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#library"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg" />
                浏览热映片单
              </a>
              <a
                href="#picks"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm md:text-base font-semibold hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-magic-line text-lg" />
                看编辑精选
              </a>
            </div>

            <dl className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-background-200">
              {heroStats.map((s) => (
                <div key={s.label}>
                  <dt className="text-xs text-foreground-500">{s.label}</dt>
                  <dd className="text-xl md:text-2xl font-bold text-foreground-950 mt-1">{s.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 animate-soft-rise">
            <div className="relative h-[360px] sm:h-[420px] lg:h-[460px]">
              {heroPosters.map((p, i) => (
                <div
                  key={p.id}
                  className="absolute w-[46%] aspect-[2/3] rounded-lg overflow-hidden border-4 border-background-50 shadow-sm"
                  style={{
                    left: i === 0 ? '2%' : i === 1 ? '30%' : '58%',
                    top: i === 1 ? '4%' : '16%',
                    zIndex: i === 1 ? 20 : 10,
                    transform: i === 1 ? 'rotate(0deg)' : i === 0 ? 'rotate(-5deg)' : 'rotate(5deg)',
                  }}
                >
                  <img
                    src={p.image}
                    alt={`${p.title} 青春电影海报`}
                    title={`${p.title} - 青苹果影院青春电影`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 z-30 bg-background-50 border border-background-200 rounded-full px-4 py-2 text-xs text-foreground-700 whitespace-nowrap">
                <i className="ri-fire-line text-accent-500 mr-1" />
                今日 2.8 万人正在挑片
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}